module.exports = __webpack_public_path__ + "static/media/xylophone-arpeggio.fe1eb160.mp3";